import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";

export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    stocks: [],
    stockProfile: {},
    categories: [],
    units: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindStockProfile: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "stockProfile",
        db.collection("stocks").doc(id)
      );
    }),
    bindStocks: firestoreAction(context => {
      return context.bindFirestoreRef("stocks", db.collection("stocks"));
    }),
    bindCategories: firestoreAction(context => {
      return context.bindFirestoreRef(
        "categories",
        db.collection("categories")
      );
    }),
    bindUnits: firestoreAction(context => {
      return context.bindFirestoreRef("units", db.collection("units"));
    })
  },
  getters: {}
};
